<ng-container *ngIf="isVisible">
  <div class="confirmation-dialog-backdrop"></div>
  <div class="confirmation-dialog-container custom-global-view {{ mobToggle ? 'w-100' : '' }}">
    <ng-content></ng-content>
  </div>
</ng-container>
